import { render, staticRenderFns } from "./vanishingTableSelection.vue?vue&type=template&id=56dde576"
import script from "./vanishingTableSelection.ts?vue&type=script&lang=js&external"
export * from "./vanishingTableSelection.ts?vue&type=script&lang=js&external"
import style0 from "./vanishingTableSelection.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports